module.exports = __webpack_public_path__ + "img/zxbank.9f70dc7a.png";